( function ( $ ) {
	document.addEventListener( 'DOMContentLoaded', function () {
		var tooltipElements = document.querySelectorAll( '[data-toggle="tooltip"]' );
		tooltipElements.forEach( function ( tooltip ) {
			$( tooltip ).tooltip();
			
			if ( tooltip.dataset.trigger === 'focus' ) {
				tooltip.addEventListener( 'click', function() {
					// forcing focus for Safari (https://bugs.webkit.org/show_bug.cgi?id=22261#c68) so that they actually open
					this.focus();
				} );
			}
			
			document.body.addEventListener( 'click', function( e ) {
				var $openTooltip = document.querySelector( '.tooltip.show' );
				
				// tooltip is open and user did not click inside
				if( $openTooltip && !$openTooltip.contains( e.target ) && $openTooltip !== e.target ) {
					var $trigger = document.querySelector( '[aria-describedby="' + $openTooltip.id + '"]' );
					if( !$trigger.contains( e.target ) && $trigger !== e.target ) {
						// did not click the trigger either
						$( $trigger ).tooltip( 'hide' ); // hide it
					}
				}
				
				if( e.target.matches( '[data-toggle="tooltip"]' ) ) {
					e.preventDefault(); // don't jump
				}
			} ); 
		} );
	} );
} ) ( jQuery );